var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Vcode',{attrs:{"show":_vm.showSlide,"canvasWidth":_vm.canvasWidth,"canvasHeight":_vm.canvasHeight,"range":5,"imgs":_vm.list},on:{"success":_vm.onSuccess,"fail":_vm.onFail,"close":_vm.handleClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }